module.exports = __webpack_public_path__ + "static/bruno_haas-3c927b99402344452dce6000662f4048.png";